import { observable, action } from "mobx";
import axios from "axios";

export default class ModalStore {

    @observable exibirModal;
    @observable activeTab;
    @observable submitted;
    @observable submitMensagemErro;
    @observable loading;
    @observable mensagemAlerta;

    constructor() {
        this.activeTab = '1';
        this.exibirModal = { tipo: null, aberto: false };
        this.submitted = false;
        this.submitMensagemErro = "";
    }

    setLoading = (value) => {
        this.loading = value;
    };

    setSubmitted = (value) => {
        this.submitted = value;
    };

    setSubmitMensagemErro = (value) => {
        this.submitMensagemErro = value;
    };

    setTab = (tab) => {
        this.activeTab = tab;
    };

    toggleModal = (tipo = null) => {
        this.activeTab = '1';
        this.exibirModal = {
            tipo,
            aberto: !this.exibirModal.aberto
        };
    };

    closeModal = (tipo = null) => {
        this.activeTab = '1';
        this.exibirModal = {
            tipo,
            aberto: false
        };
    };

}



// WEBPACK FOOTER //
// ./src/modules/comum/stores/ModalStore.js